import React from "react";
import styled from "styled-components";

import { hasValue } from "@examspark/common";
import {
  useQueryListContentSharedToWorkspace,
  useAppContext,
} from "@examspark/common-app";
import { Text, Button, Form, TextInput, VSpace } from "@examspark/common-ui";
import { IconGearLine } from "@examspark/common-ui/dist/components/icons";
import Badge from "@examspark/common-ui/dist/components/text/Badge";

import { getBankLabel } from "../../utils";

const ShareCard = styled.div`
  display: flex;
  align-items: center;
  border: solid 1px #ddd;
  padding: 1rem;
  border-radius: 0.5rem;
  background-color: #f7f7f7;
  display: flex;
  gap: 1rem;
`;
const BankBadge = styled(Badge)`
  background-color: #dad7e7;
  color: #555;
`;
const ShareCardImage = styled.div``;
const ShareCardMeta = styled.div`
  flex: 1;
`;
const ShareWorkspaceName = styled.div`
  font-size: 1.7rem;
  line-height: 1.3em;

  svg {
    margin-left: 0.5rem;
  }
`;
const ShareBanks = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;
const ShareImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border: solid 1px #ddd;
  height: 48px;
  width: 48px;
  border-radius: 100%;

  svg {
    fill: #888;
  }
`;

const Styled = styled.div`
  display: flex;
  justify-content: center;

  & > div {
    max-width: 50rem;
    flex: 1;
  }
`;

const WorkspaceOverview = () => {
  const [context] = useAppContext();
  const { data: sharedWorkspaces } = useQueryListContentSharedToWorkspace();

  return (
    <Styled>
      <div>
        <Form>
          <VSpace size="4rem">
            <VSpace>
              <Text.H2>Basic Information</Text.H2>
              <Form.Field label="Name">
                <TextInput
                  value={context.workspaceUser?.workspace?.name ?? ""}
                  disabled
                />
              </Form.Field>
              <Form.Field label="Workspace ID">
                <TextInput
                  value={context.workspaceUser?.workspace?.id ?? ""}
                  disabled
                />
              </Form.Field>
              {/* <Form.Field label="Creation Date">
              <TextInput
                value={
                  (context.workspaceUser?.workspace?.createdAt as string) ?? ""
                }
                disabled
              />
            </Form.Field> */}
              {/* <Form.Field label="Who is sharing with us?">
              <TextInput value={"Foo"} disabled />
            </Form.Field> */}
            </VSpace>

            <VSpace>
              <Text.H2>Receiving Shared Content From</Text.H2>
              <VSpace>
                {sharedWorkspaces?.map((w) => (
                  <ShareCard key={w.workspace?.id}>
                    <ShareCardImage>
                      <ShareImage>
                        <svg x="0px" y="0px" viewBox="0 0 512 512" width="24">
                          <g>
                            <g>
                              <path d="M256,193.944c-34.848,0-63.199,28.35-63.199,63.199c0,34.848,28.351,63.2,63.199,63.2c34.85,0,63.199-28.352,63.199-63.2 C319.199,222.294,290.849,193.944,256,193.944z M256,290.342c-18.305,0-33.199-14.894-33.199-33.2 c0-18.305,14.894-33.199,33.199-33.199c18.307,0,33.199,14.893,33.199,33.199C289.199,275.449,274.306,290.342,256,290.342z"></path>
                            </g>
                          </g>
                          <g>
                            <g>
                              <path d="M497,337.4h-81.4V200.422l10.926,4.967c2.014,0.915,4.123,1.349,6.199,1.349c5.701,0,11.15-3.269,13.664-8.797 c3.428-7.542,0.094-16.434-7.449-19.862L271,101.741V46.066h49.268c8.283,0,15-6.716,15-15V15c0-8.284-6.717-15-15-15H256 c-8.283,0-15,6.716-15,15v86.741L73.061,178.078c-7.541,3.428-10.877,12.32-7.447,19.862c3.426,7.542,12.32,10.875,19.861,7.448 l10.926-4.967V337.4H15c-8.283,0-15,6.716-15,15V497c0,8.284,6.717,15,15,15h96.4h96.4h96.398h96.4H497c8.285,0,15-6.716,15-15 V352.4C512,344.116,505.285,337.4,497,337.4z M96.4,482H30V367.4h66.4V482z M289.199,482h-66.398v-66.399h66.398V482z M385.6,352.4V482h-66.4v-81.399c0-8.284-6.715-15-15-15h-96.398c-8.283,0-15,6.716-15,15V482h-66.4V352.4H126.4V186.785 L256,127.876l129.6,58.909V352.4z M482,482h-66.4V367.4H482V482z"></path>
                            </g>
                          </g>
                        </svg>
                      </ShareImage>
                    </ShareCardImage>
                    <ShareCardMeta>
                      <VSpace size="0.5rem">
                        <ShareWorkspaceName>
                          {w.workspace?.name}
                        </ShareWorkspaceName>
                        <ShareBanks>
                          {w.banks
                            ?.filter(hasValue)
                            .map((b) => (
                              <BankBadge key={b.sk}>
                                {getBankLabel(b)}
                              </BankBadge>
                            ))}
                        </ShareBanks>
                      </VSpace>
                    </ShareCardMeta>
                    <div>
                      <Button
                        title="Settings"
                        icon={<IconGearLine />}
                        variant="plain"
                        disabled
                      />
                    </div>
                  </ShareCard>
                ))}
              </VSpace>
            </VSpace>
            {/* <VSpace>
              <Text.H2>Sending Shared Content To</Text.H2>
              <div>
                <ShareCard>
                  <ShareCardImage>
                    <ShareImage>
                      <svg x="0px" y="0px" viewBox="0 0 512 512" width="24">
                        <g>
                          <g>
                            <path d="M256,193.944c-34.848,0-63.199,28.35-63.199,63.199c0,34.848,28.351,63.2,63.199,63.2c34.85,0,63.199-28.352,63.199-63.2 C319.199,222.294,290.849,193.944,256,193.944z M256,290.342c-18.305,0-33.199-14.894-33.199-33.2 c0-18.305,14.894-33.199,33.199-33.199c18.307,0,33.199,14.893,33.199,33.199C289.199,275.449,274.306,290.342,256,290.342z"></path>
                          </g>
                        </g>
                        <g>
                          <g>
                            <path d="M497,337.4h-81.4V200.422l10.926,4.967c2.014,0.915,4.123,1.349,6.199,1.349c5.701,0,11.15-3.269,13.664-8.797 c3.428-7.542,0.094-16.434-7.449-19.862L271,101.741V46.066h49.268c8.283,0,15-6.716,15-15V15c0-8.284-6.717-15-15-15H256 c-8.283,0-15,6.716-15,15v86.741L73.061,178.078c-7.541,3.428-10.877,12.32-7.447,19.862c3.426,7.542,12.32,10.875,19.861,7.448 l10.926-4.967V337.4H15c-8.283,0-15,6.716-15,15V497c0,8.284,6.717,15,15,15h96.4h96.4h96.398h96.4H497c8.285,0,15-6.716,15-15 V352.4C512,344.116,505.285,337.4,497,337.4z M96.4,482H30V367.4h66.4V482z M289.199,482h-66.398v-66.399h66.398V482z M385.6,352.4V482h-66.4v-81.399c0-8.284-6.715-15-15-15h-96.398c-8.283,0-15,6.716-15,15V482h-66.4V352.4H126.4V186.785 L256,127.876l129.6,58.909V352.4z M482,482h-66.4V367.4H482V482z"></path>
                          </g>
                        </g>
                      </svg>
                    </ShareImage>
                  </ShareCardImage>
                  <ShareCardMeta>TCMPC</ShareCardMeta>
                </ShareCard>
              </div>
            </VSpace> */}
          </VSpace>
        </Form>
      </div>
    </Styled>
  );
};

export default WorkspaceOverview;
